module.exports = "mutation confirmAdvice($adviceRequestId:String!){confirmAdvice(adviceRequestId:$adviceRequestId)}"